var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"dashboard-shortcut",style:({backgroundColor: _vm.backgroundColor}),attrs:{"to":_vm.to}},[_c('div',{staticClass:"dashboard-icon"},[_vm._t("icon")],2),_c('h5',{staticClass:"dashboard-heading"},[_vm._v(_vm._s(_vm.heading))])])
}
var staticRenderFns = []

export { render, staticRenderFns }